module.exports = "/_next/static/images/app_store_badge-73b5cf0e11f03dabb2e035279daa76c5.svg";